const STORAGE_KEY = 'relai_lang';

const languagePopup = {
  selectedUrl: '',
  selectedLang: '',

  init() {
    this.popup = document.querySelector('.popup--language');
    if (!this.popup) return;

    this.selectedUrl = this.popup.getAttribute('data-selected-url') || '';
    this.selectedLang = this.popup.getAttribute('data-selected-lang') || '';

    this.popupContent = this.popup.querySelector('[data-popup-content]');
    this.langSelect = this.popup.querySelector('[data-language-select]');
    this.langToggle = this.popup.querySelector('[data-language-toggle]');
    this.langList = this.popup.querySelector('[data-language-list]');
    this.countrySelect = this.popup.querySelector('[data-country-select]');
    this.countryToggle = this.popup.querySelector('[data-country-toggle]');
    this.countryList = this.popup.querySelector('[data-country-list]');

    if (!this.langToggle || !this.langList) return;

    this.setupDropdown(this.langToggle, this.langList, this.langSelect, (link) => this.onLanguageSelect(link));

    if (this.countryToggle && this.countryList && this.countrySelect) {
      this.setupDropdown(this.countryToggle, this.countryList, this.countrySelect, (link) => this.onCountrySelect(link));
    }

    this.popup.querySelector('[data-popup-save]')?.addEventListener('click', () => this.save());

    document.getElementById('lang-switcher-btn')?.addEventListener('click', () => this.open());

    const pageLang = (window.location.pathname.split('/')[1] || '').toLowerCase();
    if (!localStorage.getItem(STORAGE_KEY) && pageLang.startsWith('de')) {
      this.open();
    }
  },

  open() {
    this.popup.classList.add('active');
  },

  save() {
    localStorage.setItem(STORAGE_KEY, this.selectedLang);
    if (this.selectedUrl) {
      window.location.href = this.selectedUrl;
    } else {
      this.popup.classList.remove('active');
    }
  },

  // Dropdown Functionality

  getLabel(toggle) {
    return toggle.querySelector('span:not(.popup__label):not(.popup__select-chevron)');
  },

  getVisibleItems(list) {
    return [...list.querySelectorAll('.popup__select-link')].filter((el) => !el.closest('[hidden]'));
  },

  openDropdown(toggle, list) {
    toggle.setAttribute('aria-expanded', 'true');
    const items = this.getVisibleItems(list);
    const active = list.querySelector('.popup__select-item--active:not([hidden]) .popup__select-link');
    (active || items[0])?.focus();
  },

  closeDropdown(toggle, returnFocus) {
    toggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) toggle.focus();
  },

  setupDropdown(toggle, list, container, onSelect) {
    toggle.addEventListener('click', () => {
      toggle.getAttribute('aria-expanded') === 'true'
        ? this.closeDropdown(toggle, true)
        : this.openDropdown(toggle, list);
    });

    toggle.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.openDropdown(toggle, list);
      }
    });

    list.addEventListener('keydown', (e) => {
      const items = this.getVisibleItems(list);
      const currentIndex = items.indexOf(document.activeElement);

      const keyActions = {
        'ArrowDown': () => {
          e.preventDefault();
          items[(currentIndex + 1) % items.length].focus();
        },
        'ArrowUp': () => {
          e.preventDefault();
          items[(currentIndex - 1 + items.length) % items.length].focus();
        },
        'Home': () => {
          e.preventDefault();
          items[0].focus();
        },
        'End': () => {
          e.preventDefault();
          items[items.length - 1].focus();
        },
        'Escape': () => {
          e.preventDefault();
          this.closeDropdown(toggle, true);
        },
        'Tab': () => {
          this.closeDropdown(toggle, false);
        },
        'Enter': () => {
          e.preventDefault();
          if (currentIndex >= 0) onSelect(items[currentIndex]);
        },
        ' ': () => {
          e.preventDefault();
          if (currentIndex >= 0) onSelect(items[currentIndex]);
        }
      };

      const action = keyActions[e.key];
      if (action) action();
    });

    list.addEventListener('click', (e) => {
      const link = e.target.closest('.popup__select-link');
      if (link && !link.closest('[hidden]')) {
        e.preventDefault();
        onSelect(link);
      }
    });

    (this.popupContent || document).addEventListener('click', (e) => {
      if (toggle.getAttribute('aria-expanded') === 'true' && !container.contains(e.target)) {
        this.closeDropdown(toggle, false);
      }
    });
  },

  // Country Selection

  showCountrySelect(languageBase) {
    if (!this.countrySelect) return;

    this.countrySelect.hidden = false;

    this.countryList.querySelectorAll('[data-base]').forEach((item) => {
      item.hidden = item.getAttribute('data-base') !== languageBase;
    });

    const firstLink = this.countryList.querySelector(`[data-base="${languageBase}"]:not([hidden]) .popup__select-link`);
    if (firstLink) {
      this.syncToggleWithLink(this.countryToggle, firstLink);
      this.selectedUrl = firstLink.getAttribute('href') || firstLink.closest('a')?.href || '';
      this.selectedLang = firstLink.getAttribute('lang') || languageBase;
    }
  },

  syncToggleWithLink(toggle, link) {
    const img = link.querySelector('img');
    const span = link.querySelector('span');
    const toggleImg = toggle.querySelector('img');
    const toggleLabel = this.getLabel(toggle);

    if (toggleImg && img) {
      toggleImg.src = img.src;
    } else if (!toggleImg && img) {
      toggle.insertBefore(img.cloneNode(true), toggle.firstChild);
    }
    if (toggleLabel && span) {
      toggleLabel.textContent = span.textContent;
    }
  },

  // Selection Handlers

  onLanguageSelect(link) {
    const item = link.closest('.popup__select-item');
    const url = item.getAttribute('data-url');
    const localeCount = parseInt(item.getAttribute('data-locales'), 10);
    const languageBase = item.getAttribute('data-base');

    this.highlightSelectedItem(this.langList, '.popup__select-item', item);
    this.getLabel(this.langToggle).textContent = link.textContent.trim();
    this.closeDropdown(this.langToggle, false);

    if (localeCount === 1 && url) {
      this.selectedUrl = url;
      this.selectedLang = languageBase;
      if (this.countrySelect) this.countrySelect.hidden = true;
    } else {
      this.showCountrySelect(languageBase);
    }
  },

  onCountrySelect(link) {
    const href = link.getAttribute('href') || link.closest('a')?.href;
    const lang = link.getAttribute('lang');

    if (href && href !== '#') {
      this.selectedUrl = href;
      this.selectedLang = lang || '';
    }

    this.syncToggleWithLink(this.countryToggle, link);
    this.closeDropdown(this.countryToggle, false);

    const languageBase = link.closest('[data-base]')?.getAttribute('data-base');
    if (languageBase) {
      const itemsInBase = this.countryList.querySelectorAll(`[data-base="${languageBase}"]`);
      const selectedItem = link.closest('.popup__select-item');
      this.highlightSelectedItem(itemsInBase, null, selectedItem);
    }
  },

  highlightSelectedItem(container, selector, itemToHighlight) {
    const items = selector ? container.querySelectorAll(selector) : container;
    items.forEach((item) => {
      item.classList.remove('popup__select-item--active');
      item.removeAttribute('aria-selected');
    });
    itemToHighlight?.classList.add('popup__select-item--active');
    itemToHighlight?.setAttribute('aria-selected', 'true');
  },
};

window.addEventListener('DOMContentLoaded', () => languagePopup.init());